// Lucide icon: file-spreadsheet (https://lucide.dev/icons/file-spreadsheet)
import { FileSpreadsheet } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconFileSpreadsheet = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <FileSpreadsheet />
    </IconComponentStyled>
  )
}
